module.exports = __webpack_public_path__ + "static/img/report_logo_direita.e6f1985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report_logo_direita.jpg
// module id = MDs9
// module chunks = 0